"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialDataHelper = void 0;
class TutorialDataHelper {
    static async loadAvatars() {
        try {
            const response = await this.apiService.back.get('avatar.list', {
                queryParams: { per_page: '1000' }
            });
            if (response && response.success && response.data) {
                this.availableAvatars = response.data;
            }
        }
        catch (error) {
            console.error('Failed to load avatars:', error);
            this.popupService.error('tutorial.errors.avatarsLoadFailed'.t());
        }
    }
    static async loadKnowledgeOptions() {
        try {
            const response = await this.apiService.back.get('knowledge.list', {
                queryParams: { per_page: '100', picker: '1' }
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.knowledgeOptions = response.data
                    .filter((knowledge) => knowledge.contentType !== 'link')
                    .map((knowledge) => ({ value: knowledge.id.toString(), label: knowledge.title }));
            }
        }
        catch (error) {
            console.error('Failed to load knowledge options:', error);
        }
    }
    static async getCategories() {
        const response = await this.apiService.back.get('tutorial.category.list', { queryParams: { all: '1' } });
        if (response && response.success && Array.isArray(response.data)) {
            this.categoryOptions = [
                { label: 'tutorial.form.no_cat'.t(), value: null },
                ...response.data.map((item) => ({
                    label: item.name,
                    value: Number(item.id),
                }))
            ];
        }
        else {
            this.popupService.error('tutorial.category.loadFailed'.t());
        }
    }
    static async loadTutorial() {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            this.loading = true;
            const response = await this.apiService.back.get('tutorial.get', {
                routeParams: { id: this.tutorialId }
            });
            if (response && response.success && response.data) {
                this.form = {
                    id: (_a = response.data.id) === null || _a === void 0 ? void 0 : _a.toString(),
                    name: response.data.name,
                    description: response.data.description || '',
                    introText: response.data.introText || '',
                    tutorialGoal: response.data.tutorialGoal || '',
                    expireAt: response.data.expireAt ? new Date(response.data.expireAt).toISOString().slice(0, 10) : null,
                    active: (_b = response.data.active) !== null && _b !== void 0 ? _b : true,
                    draft: (_c = response.data.draft) !== null && _c !== void 0 ? _c : false,
                    creator: response.data.creator || null,
                    avatar: response.data.avatar || null,
                    logo: response.data.logo || null,
                    instructionFile: response.data.instructionFile || null,
                    categoryId: Number((_d = response.data.category) === null || _d === void 0 ? void 0 : _d.id) || null,
                    source: response.data.source || 'ai',
                    sourceFile: response.data.sourceFile || null,
                    scanPagesFrom: (_e = response.data.scanPagesFrom) !== null && _e !== void 0 ? _e : null,
                    scanPagesTo: (_f = response.data.scanPagesTo) !== null && _f !== void 0 ? _f : null,
                    hours: (_g = response.data.hours) !== null && _g !== void 0 ? _g : null
                };
                this.onboardingAttached = response.data.onboardingPayload || null;
                this.steps = TutorialDataHelper.mapTutorialSteps(response.data.tutorialSteps || []);
                this.updateChatTools();
                this.renderSectionSourceHtml();
            }
        }
        catch (error) {
            console.error('Failed to load tutorial:', error);
            this.popupService.error('tutorial.errors.loadFailed'.t());
        }
        finally {
            this.loading = false;
        }
    }
    static mapTutorialSteps(tutorialSteps) {
        return tutorialSteps.map((tutorialStep, index) => {
            var _a, _b;
            return ({
                id: (_a = tutorialStep.id) === null || _a === void 0 ? void 0 : _a.toString(),
                title: tutorialStep.title || `${'tutorial.form.step'.t()} ${index + 1}`,
                order: tutorialStep.order || index + 1,
                sections: ((_b = tutorialStep.tutorialSections) === null || _b === void 0 ? void 0 : _b.map((s) => {
                    var _a, _b, _c, _d, _e, _f;
                    return ({
                        id: (_a = s.id) === null || _a === void 0 ? void 0 : _a.toString(),
                        title: s.title,
                        description: s.description || '',
                        prompt: s.prompt || '',
                        order: s.order || 1,
                        knowledgeIds: ((_b = s.knowledgeEntries) === null || _b === void 0 ? void 0 : _b.map(k => { var _a; return (_a = k.id) === null || _a === void 0 ? void 0 : _a.toString(); })) || [],
                        todoItems: TutorialDataHelper.mapSectionTodoItems(s.tutorialSectionTodos),
                        screenshot: s.screenFile || null,
                        video: s.videoFile || null,
                        screenshotMini: s.screenMiniFile || null,
                        videoMini: s.videoMiniFile || null,
                        tutorialSectionFiles: (s.tutorialSectionFiles || []).map(sectionFile => ({
                            id: sectionFile.id,
                            file: sectionFile.file,
                            mini: sectionFile.mini || null
                        })),
                        sourcePagesFrom: (_d = (_c = s.sourcePages) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : null,
                        sourcePagesTo: (_f = (_e = s.sourcePages) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : null,
                        sourceText: s.sourceText || '',
                        formData: s.formData || ''
                    });
                })) || []
            });
        });
    }
    // Todo items come from all todos associated with the section via the junction table
    static mapSectionTodoItems(tutorialSectionTodos) {
        if (!tutorialSectionTodos || !Array.isArray(tutorialSectionTodos)) {
            return [];
        }
        return tutorialSectionTodos.flatMap((junction) => {
            const todo = junction.todo;
            if (!todo || !Array.isArray(todo.items)) {
                return [];
            }
            return todo.items.map((item, itemIndex) => ({
                title: item.title || '',
                description: item.description || '',
                done: item.done || false,
                order: item.order || itemIndex + 1
            }));
        });
    }
}
exports.TutorialDataHelper = TutorialDataHelper;
